import { createStore } from 'satcheljs';
import RecipientCacheStore from './schema/RecipientCacheStore';

var initialRecipientCacheStore: RecipientCacheStore = {
    recipientCache: null,
    allKeys: {},
    usedFindPeopleFallback: false,
};
var store = createStore<RecipientCacheStore>('recipientcache', initialRecipientCacheStore)();

export default store;
